export const initPasswordWrapper = () => {
  // Password wrapper toggle functionality
  const passwordWrappers = document.querySelectorAll('.password-wrapper');
  passwordWrappers.forEach((passwordWrapper) => {
    const toggleBtn = passwordWrapper.querySelector('.password-toggle');
    const passwordInput = passwordWrapper.querySelector('.password-input');
    const eyeIcon = toggleBtn.querySelector('i');

    toggleBtn.addEventListener('click', function () {
      const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
      passwordInput.setAttribute('type', type);

      // Toggle between eye and eye-slash properly
      if (type === 'password') {
        eyeIcon.classList.remove('ri-eye-line');
        eyeIcon.classList.add('ri-eye-off-line');
      } else {
        eyeIcon.classList.remove('ri-eye-off-line');
        eyeIcon.classList.add('ri-eye-line');
      }

      // Ensure '' and 'text-muted' classes are always present
      eyeIcon.classList.add('text-muted');
    });
  });
};
